// Auto generated file, do not manually modify!
// com.hotpads.maintenancetracker.web.users.task.handler.MaintenanceTrackerTaskUserWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  MaintenanceCreateTaskRequestDto,
  MaintenanceCreateTaskResponseDto,
  MaintenanceTaskStatus,
  MaintenanceTrackerTaskDetailsResponseDto,
  MaintenanceUpdateTaskRequestDto,
  MaintenanceUpdateTaskResponseDto,
} from '../..';

interface DeleteParams {
  maintenanceTaskId: string;
}
interface DetailsParams {
  maintenanceTaskId: string;
}
interface UpdateDateCompletedParams {
  completedTimestampMs: number;
  maintenanceTaskId: string;
}
interface UpdateStatusParams {
  maintenanceTaskId: string;
  status: MaintenanceTaskStatus;
}

export const MaintenanceTrackerTaskUserWebApiHandler_create_Path = '/api/v1/users/maintenance/tasks/create';

/**
 * Create a maintenance task
 */
export const MaintenanceTrackerTaskUserWebApiHandler_create = (
  postData: MaintenanceCreateTaskRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, MaintenanceCreateTaskRequestDto, MaintenanceCreateTaskResponseDto>(
    {
      endpoint: MaintenanceTrackerTaskUserWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/maintenance-tracker',
      postData: postData,
    },
    client,
  );
};

export const MaintenanceTrackerTaskUserWebApiHandler_delete_Path = '/api/v1/users/maintenance/tasks/delete';

/**
 * Delete a maintenance task
 */
export const MaintenanceTrackerTaskUserWebApiHandler_delete = (getParams: DeleteParams, client = getClient()) => {
  return httpFrontEndRequest<DeleteParams, never, void>(
    {
      getParams: getParams,
      endpoint: MaintenanceTrackerTaskUserWebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/maintenance-tracker',
    },
    client,
  );
};

export const MaintenanceTrackerTaskUserWebApiHandler_details_Path = '/api/v1/users/maintenance/tasks/details';

/**
 * Get a maintenance task's details
 */
export const MaintenanceTrackerTaskUserWebApiHandler_details = (getParams: DetailsParams, client = getClient()) => {
  return httpFrontEndRequest<DetailsParams, never, MaintenanceTrackerTaskDetailsResponseDto>(
    {
      getParams: getParams,
      endpoint: MaintenanceTrackerTaskUserWebApiHandler_details_Path,
      method: 'GET',
      contextPath: '/maintenance-tracker',
    },
    client,
  );
};

export const MaintenanceTrackerTaskUserWebApiHandler_update_Path = '/api/v1/users/maintenance/tasks/update';

/**
 * Update a maintenance task
 */
export const MaintenanceTrackerTaskUserWebApiHandler_update = (
  postData: MaintenanceUpdateTaskRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, MaintenanceUpdateTaskRequestDto, MaintenanceUpdateTaskResponseDto>(
    {
      endpoint: MaintenanceTrackerTaskUserWebApiHandler_update_Path,
      method: 'POST',
      contextPath: '/maintenance-tracker',
      postData: postData,
    },
    client,
  );
};

export const MaintenanceTrackerTaskUserWebApiHandler_updateDateCompleted_Path =
  '/api/v1/users/maintenance/tasks/updateDateCompleted';

/**
 * Update a maintenance task's complete date
 */
export const MaintenanceTrackerTaskUserWebApiHandler_updateDateCompleted = (
  getParams: UpdateDateCompletedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<UpdateDateCompletedParams, never, MaintenanceUpdateTaskResponseDto>(
    {
      getParams: getParams,
      endpoint: MaintenanceTrackerTaskUserWebApiHandler_updateDateCompleted_Path,
      method: 'POST',
      contextPath: '/maintenance-tracker',
    },
    client,
  );
};

export const MaintenanceTrackerTaskUserWebApiHandler_updateStatus_Path = '/api/v1/users/maintenance/tasks/updateStatus';

/**
 * Update a maintenance task's status
 */
export const MaintenanceTrackerTaskUserWebApiHandler_updateStatus = (
  getParams: UpdateStatusParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<UpdateStatusParams, never, MaintenanceUpdateTaskResponseDto>(
    {
      getParams: getParams,
      endpoint: MaintenanceTrackerTaskUserWebApiHandler_updateStatus_Path,
      method: 'POST',
      contextPath: '/maintenance-tracker',
    },
    client,
  );
};
